import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledButton } from './comment-button.styles';
import OpenDocIcon from '@icons/editor/open-doc-icon';

const OpenDocButton = ({ isMobile }) => {
  const [, dispatch] = useContext(Context);

  return (
    <StyledButton
      data-ignore-click-outside="sidebar"
      onClick={() => {
        dispatch({ type: 'TOGGLE_EDITOR_OPEN_DOC_MODAL' });
      }}
      title="Выбрать документ"
    >
      <OpenDocIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} />
    </StyledButton>
  );
};

export default OpenDocButton;